import React, {useState, useEffect} from 'react'
import {getData} from '../../helpers/api';
import moment from 'moment';

export default function Orders() {
    const [orderData, setOrderData] = useState([])

    useEffect(() => {
        getOrders()
    }, [])

    const getOrders = () => {
        getData(`${process.env.REACT_APP_APP_API_URL}/api/order`).then(res => {
            console.log(res)
          setOrderData(res.data.orders);
        }).catch(e => console.log(e))
    }

    return (
        <>
            <ul className="c_8 timeline">
                <li id="new_post">
                    <div className="box add">
                        <span className="title">Orders</span>
                        <div className="table-responsive">
                          <table className="table table-striped table-hover">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Product Name</th>
                                <th>Price</th>
                                <th>Quantity</th>
                                <th>Status</th>
                                <th>Time</th>
                              </tr>
                            </thead>
                              <tbody>
                                {orderData && orderData.map((cat, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{cat.product.name}</td>
                                        <td>{cat.price}</td>
                                        <td>{cat.quantity}</td>
                                        <td>{cat.status}</td>
                                        <td>{moment(cat.createdAt).format('YYYY-MM-DD HH:mm')}</td>
                                      </tr>
                                    )
                                  })
                                }
                              </tbody>
                            </table>
                        </div>
                    </div>
                </li>
            </ul>
        </>
    )
}